import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useTypingPlaceholders } from "./useTypingPlaceholders.js";
import { getPersona } from "../../definitions/modelPlaceholders";
import "./typingAnimation.scss";

export default function TypingAnimation({ text = "", model = "latest", isGenerating = false }) {
  const [content, setContent] = useState("");
  const [index, setIndex] = useState(0);
  const [done, setDone] = useState(false);

  const placeholder = useTypingPlaceholders(model, isGenerating && content.length === 0);
  const { streamDelayMs } = getPersona(model);

  useEffect(() => {
    setContent("");
    setIndex(0);
    setDone(false);
  }, [text]);

  useEffect(() => {
    if (!text) return;

    // Use persona delay if larger, else fall back to a slow default.
    const MIN_DELAY = 120; // was 35 — ~3–4× slower
    const delay = Math.max(streamDelayMs ?? 35, MIN_DELAY);

    const interval = setInterval(() => {
      if (index < text.length) {
        setContent((prev) => prev + text[index]);
        setIndex((prev) => prev + 1);
      } else {
        clearInterval(interval);
        setDone(true);
      }
    }, delay);

    return () => clearInterval(interval);
  }, [text, index, streamDelayMs]);

  const showPlaceholder = isGenerating && content.length === 0;

  return (
    <div className="typing-animation">
      {showPlaceholder ? (
        <p className="placeholder-row">
          <span className="placeholder-text">{placeholder}</span>
          <span className="blinking-cursor">|</span>
        </p>
      ) : (
        <>
          <ReactMarkdown>{content}</ReactMarkdown>
          {(isGenerating || !done) && <span className="blinking-cursor">|</span>}
        </>
      )}
    </div>
  );
}
